import React, { useState } from "react";
import { Button, Card, Chip, Delimiter, Typography } from "@otp/ui";
import { useTranslation } from "react-i18next";

import { getAddress } from "src/utils/restaurant-data";
import { StoreModel } from "src/graphql/generated/graphql";
import { OtpBreakdownItem } from "./otp-breakdown-item";
import styles from "./popup.module.css";
import { OTPsManagementModal } from "src/components/manage-restaurants/details/otps/otps-management-modal";

type RestaurantsMapProps = {
  className?: string;
  store: Partial<StoreModel>;
};

export const RestaurantsMapPopup = ({ store }: RestaurantsMapProps) => {
  const { t } = useTranslation();
  const storeUsersCountByLevel = store.storeUsersCountByLevel;
  const [displayOTPsModal, setDisplayOTPsModal] = useState(false);

  const showOTPsModal = () => {
    setDisplayOTPsModal(true);
  };

  const hideOTPsModal = () => {
    setDisplayOTPsModal(false);
  };

  return (
    <Card noBorder className="p-3 w-full">
      <Chip label={`#${store.nationalStoreNumber}`} className="-ml-1" />
      <Typography
        fontWeight="bold"
        variant="subtitle1"
        component="div"
        className="mt-1.5"
      >
        {store.name}
      </Typography>
      <Typography variant="subtitle2" component="div">
        {getAddress(store)}
      </Typography>
      <div className="mt-3 flex flex-col gap-2">
        <OtpBreakdownItem
          label="OTP3"
          count={storeUsersCountByLevel?.["otp-3"] || 0}
        />
        <OtpBreakdownItem
          label="OTP2"
          count={storeUsersCountByLevel?.["otp-2"] || 0}
        />
        <OtpBreakdownItem
          label="OTP1"
          count={storeUsersCountByLevel?.["otp-1"] || 0}
        />
        <OtpBreakdownItem
          label="OTP0"
          count={storeUsersCountByLevel?.["otp-0"] || 0}
        />
      </div>
      {store.isNeedAttention && (
        <Chip
          label={t(
            "manage-restaurants.map.popup.store-needs-attention-alert",
            "This store does not have OTP2+ level OTP assigned",
          )}
          color="error"
          className={styles.needAttentionChip}
        />
      )}
      <Delimiter className="py-2" />
      <div className="flex justify-end">
        <Button
          variant="contained"
          color="primary"
          onClick={showOTPsModal}
          size="small"
        >
          {t("manage-restaurants.map.popup.assign-otp")}
        </Button>
        <OTPsManagementModal
          store={store}
          open={displayOTPsModal}
          onClose={hideOTPsModal}
        />
      </div>
    </Card>
  );
};
